import * as React from "react";
import CountDown from "../CountDown";
import { SingleCardWrap } from "../styles.card";
import { ProductCardProps } from "./index";

import { BannerContainer } from "../../../../components/BannerContainer";
import { ProductInfoGrid1 } from "../../../LayerUI/ProductInfoViews";
import { ProductImageTagViews } from "../../../LayerUI/ImageTagViews";
import { transformAParam } from "utils/browser";
import { LinkTargetType } from "../../../../services/playground";

const SingleCard = (props: ProductCardProps) => {
	const {
		productElement,
		columnNum,
		layoutStyle,
		placeholderBg,
		qnParams = {},
		isInApp,
		collectOptions = {},
		stylesForCard = { width: "7.5rem", height: "7.5rem" },
		poolId,
	} = props;
	const collect = productElement.extra?.collect;
	const titleIcon = productElement.extra?.titleIcon?.img;
	const topRightTag = productElement.extra?.imgOnTopRight;
	const topLeftTag = productElement.extra?.imgOnTopLeft;
	const topLeftTag2 = productElement.extra?.imgOnTopLeft2;
	const bottomLeftTag = productElement.extra?.imgOnBottomLeft;
	const flash = productElement.extra?.flash;
	const aProps = transformAParam({
		isInApp: !!isInApp,
		link: productElement.url,
		aTarget: LinkTargetType.Blank,
		onClick: props.onClick,
	});

	return (
		<SingleCardWrap
			{...aProps}
			style={{ height: stylesForCard?.height || "auto" }}
			id={`${poolId}${productElement.gpid}`}
		>
			<BannerContainer
				banner={{
					img: productElement.img,
					link: productElement.url,
				}}
				style={{
					position: "relative",
					flex: "0 0 auto",
					...stylesForCard,
				}}
				placeholderBg={placeholderBg}
				qnParams={{ ...qnParams }}
				keepSize={true}
				gridHeight="100%"
			>
				<ProductImageTagViews
					columnNum={1}
					rightTopTag={topRightTag}
					leftTopTag={topLeftTag}
					leftTopTag2={topLeftTag2}
					leftBottomTag={bottomLeftTag}
					isOnlyShowLeftTopTag={true}
					isShowFlashOrPromotion={true}
				/>

				{flash?.countdownToEnd && (
					<CountDown
						needEndsIn={false}
						countInfo={flash}
						needIcon={false}
						needIconImg={true}
					/>
				)}
			</BannerContainer>

			<ProductInfoGrid1
				columnNum={columnNum || 1}
				price={productElement.price}
				originPrice={productElement.originPrice}
				name={productElement.name}
				titleIcon={titleIcon}
				collect={collect}
				collectOptions={collectOptions}
				actTags={productElement.extra.actTags}
				layoutStyle={layoutStyle}
				priceCurrency={productElement.priceCurrency}
				originPriceCurrency={productElement.originPriceCurrency}
				priceSymbol={productElement.priceSymbol}
				originPriceSymbol={productElement.originPriceSymbol}
			/>
		</SingleCardWrap>
	);
};
export default SingleCard;
